import { useState, useMemo } from 'react';
import styled from '@emotion/styled';
import { mergeProps, useButton, useFocus } from 'react-aria';

import { useDevice, useDevicesSelection } from '../../../store/devices/useDevices.ts';

import { theme } from '../../../theme/theme';

import { Icon } from '../../common/Icon';

import { iconChevronDown } from '../../../theme/icons/interface/chevron-down';
import { iconWarning } from '../../../theme/icons/interface/warning/warning';

const fallback = [];

export function SelectPreviewDeviceDeviceControls(props) {
  const button = useButton(props.select.triggerProps, props.previewRef);
  const [isFocused, setIsFocused] = useState(false);
  const focus = useFocus({
    onFocusChange: setIsFocused,
  });

  const { device } = useDevice({ deviceId: props.state.selectedItem?.key });
  const selection = useDevicesSelection({
    deviceIds:
      device?.driverId === 'homey:virtualdrivergroup:driver'
        ? device?.settings.deviceIds
        : fallback,
  });

  const isSomeDeviceUnavailable = useMemo(() => {
    return Object.values(selection).some((device) => {
      // If the device was not found ignore it for the available status.
      if (device == null) {
        return false;
      }

      return device.available === false;
    });
  }, [selection]);

  return (
    <S.Input
      {...mergeProps(button.buttonProps, focus.focusProps)}
      ref={props.previewRef}
      title={props.state.selectedItem?.textValue}
      data-is-open={props.state.isOpen}
      data-is-focused={isFocused}
    >
      {(isSomeDeviceUnavailable || device?.available === false) && (
        <S.Icon url={iconWarning} size={theme.icon.size_18} color={theme.color.icon_light} />
      )}

      <S.Text>{device?.name ?? props.state.selectedItem?.textValue}</S.Text>

      {props.select.triggerProps.isDisabled !== true && (
        <S.ChevronDownIcon
          url={iconChevronDown}
          color={theme.color.icon_light}
          size={theme.icon.size_small}
        />
      )}
    </S.Input>
  );
}

function S() {}
SelectPreviewDeviceDeviceControls.S = S;

S.Input = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  min-width: 0;
  width: 100%;
  height: 37px;
  padding: 6px 10px;
  gap: 5px;
  border: 1px solid transparent;
  outline: 0;
  cursor: pointer;

  &[data-is-open='true'],
  &[data-is-focused='true'] {
    //border: 1px solid ${theme.input.border_focus};
  }

  color: ${theme.color.white};
  font-size: ${theme.fontSize.medium};
  font-weight: ${theme.fontWeight.bold};
  line-height: 22px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

S.Icon = styled(Icon)`
  flex: 0 0 ${theme.icon.size_18};
`;

S.Text = styled.span`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: start;
`;

S.ChevronDownIcon = styled(Icon)`
  flex: 0 0 ${theme.icon.size_small};
`;
